export function arrayBufferToBase64Url(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }

  const btoa = (globalThis as { btoa?: (data: string) => string }).btoa;
  if (btoa) return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

  const BufferCtor = (
    globalThis as {
      Buffer?: {
        from: (data: string, encoding: string) => { toString: (encoding: string) => string };
      };
    }
  ).Buffer;
  if (!BufferCtor) throw new Error('base64_unavailable');

  return BufferCtor.from(binary, 'binary')
    .toString('base64')
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

export async function sha256Base64Url(input: string): Promise<string> {
  const subtle = (
    globalThis as {
      crypto?: {
        subtle?: { digest: (algorithm: string, data: Uint8Array) => Promise<ArrayBuffer> };
      };
    }
  ).crypto?.subtle;
  if (!subtle) throw new Error('sha256_unavailable');

  const TextEncoderCtor = (
    globalThis as { TextEncoder?: new () => { encode: (input: string) => Uint8Array } }
  ).TextEncoder;
  if (!TextEncoderCtor) throw new Error('text_encoder_unavailable');

  const digest = await subtle.digest('SHA-256', new TextEncoderCtor().encode(input));
  return arrayBufferToBase64Url(digest);
}
